import Api from "../../../api/api";

export default {
  ovchipkaart: function (message) {
    return this.test("ovchipkaart", message, function (value) {
      if (!value || value.length !== 16) return false;

      value = value.replace(/ /g, "");
      for (
        var i = value.length,
          n = 0,
          list = [
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
          ],
          o = 0;
        i--;

      ) {
        var char = parseInt(value.charAt(i), 10);
        o += list[n][char];
        n ^= 1;
      }
      return o % 10 === 0 && o > 0;
    });
  },
  maxLength: function (maxLength, message) {
    return this.test("max", message, function (value) {
      if (value !== undefined && value !== null) {
        value = value.replace(/\n/g, "\n\r"); //Count enters as 2 characters. So that if fits in the database column.
      }
      return !value || value.length <= maxLength;
    });
  },
  maxSize: function (maxSize, message) {
    return this.test("maxsize", message, function (value) {
      const input = document.querySelector(`[name="${this.path}"]`);
      if (!maxSize || !input || !value || !input.files.length) {
        return true;
      }
      const bytes = input.files[0].size;
      return bytes < maxSize;
    });
  },
  postalcode: function (message) {
    return this.test("postalcode", message, function (value) {
      if (!value || value.length === 0) return true;
      if (value.length !== 6) return false;
      return value.match(/^[1-9][0-9]{3}[A-z]{2}$/i);
    });
  },
  commaDecimal: function (message) {
    return this.test("commaDecimal", message, function (value) {
      if (!value) return true;
      return /^\d*,{0,1}\d{1,2}$/g.test(value);
    });
  },
  hiddenChars: function (message) {
    return this.test("hiddenChars", message, function (value) {
      const validAsciiChars = /^[ -ÿ]+$/.test(value);
      const hiddenAsciiChars = /[\u00AD\u00A0]/.test(value);

      if (!validAsciiChars || hiddenAsciiChars) {
        return false;
      }
      return true;
    });
  },
  normalChars: function (message) {
    return this.test("normalChars", message, function (value) {
      return /^[a-zA-Z0-9 .@_-]*$/.test(value);
    });
  },
  validNumberOfFreeEtickets: function (price, url, email, startDate, message) {
    let timeout = null;
    return this.test("validNumberOfFreeEtickets", message, function () {
      clearTimeout(timeout);
      console.log(price);
      return new Promise((resolve) => {
        timeout = setTimeout(async () => {
          Api.getFreeEticketsValidity(url, price, email, startDate).then(
            async (res) => {
              const data = await res.data;
              if (!data.isValid && data.errorMessage) {
                resolve(this.createError({ message: data.errorMessage }));
              }
            }
          );
        }, 1000);
      });
    });
  },
  validDiscountCode: function (
    skuId,
    url,
    discountCantBeAppliedMessage,
    message
  ) {
    let timeout = null;
    return this.test("validDiscountCode", message, function (value) {
      clearTimeout(timeout);
      if (!value) {
        clearDiscount();
        return true;
      }
      return new Promise((resolve) => {
        timeout = setTimeout(async () => {
          Api.getDiscountCodeValidity(value, skuId, url)
            .then(async (res) => {
              const data = await res.data;
              if (data.errorMessage) {
                clearDiscount();
                resolve(this.createError({ message: data.errorMessage }));
              }
              if (document.getElementById("Amount").innerText != 1) {
                clearDiscount();
                resolve(
                  this.createError({
                    message: discountCantBeAppliedMessage,
                  })
                );
              }
              if (
                document.getElementById("Amount").innerText == 1 &&
                data.discountValue &&
                data.finalPrice
              ) {
                applyDiscount(data);
                resolve(true);
              }
            })
            .catch(() => {
              resolve(false);
            });
        }, 1000);
      });
    });
  },
};

function clearDiscount() {
  document.getElementById("Discount").parentElement.style.display = "none";
  document.getElementById("Price").className = "";
  document.getElementById("DiscountPrice").style.display = "none";
  document.getElementById("OrderAmount").style.display = "initial";
  document.getElementById("DiscountOrderAmount").style.display = "none";
}

function applyDiscount(data) {
  document.getElementById("Discount").parentElement.style.display = "list-item";
  document.getElementById("Discount").innerText = data.discountValue + "%";
  document.getElementById("Price").className = "container--diagonal-strike";
  document.getElementById("DiscountPrice").style.display = "initial";
  document.getElementById("DiscountPrice").innerText = " € " + data.finalPrice;
  document.getElementById("OrderAmount").style.display = "none";
  document.getElementById("DiscountOrderAmount").style.display = "initial";
  document.getElementById("DiscountOrderAmount").innerText =
    " € " + data.finalPrice;
}



// WEBPACK FOOTER //
// ./src/components/Form/Validation/StringValidation.js